import {
  InternalConfigObject,
  CreateExtractCssFromPropsParams,
  Property,
} from '../core.types';
import { createParser } from './utils/createParser';
import { createStyleFunction } from './utils/createStyleFunction';

/**
 * this is the entry point of the style system and is used to create a parser function that maps the props to the appropriate css
 * @param args an object containing the config of the properties to be mapped to css
 * @returns a function that maps the props to the appropriate css
 */

export const createExtractCssFromProps = (
  args: CreateExtractCssFromPropsParams = {},
) => {
  const config: InternalConfigObject = {};
  Object.keys(args).forEach((key) => {
    const conf = args[key as keyof typeof args];
    // if the value is true, we use the key as the property name
    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        themeKey: key,
      });
      return;
    }
    // if the value is a function, we use it directly
    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }
    // otherwise we use the config object
    config[key] = createStyleFunction(conf as Property);
  });

  const parser = createParser(config);
  return parser;
};
